import styled from "styled-components";

export const ExternalLink = styled.a`
  color: ${({ theme }) => theme.colors.grayThick};
`;
